// extracted by mini-css-extract-plugin
export default {"container":"ChargingEventsModalTabs_container__x4Qws","tab":"ChargingEventsModalTabs_tab__mqkRV","text":"ChargingEventsModalTabs_text__XEEyj"};